import { all, fork, put, takeEvery } from "redux-saga/effects";
import { SIGNIN_USER, SIGNOUT_USER } from "constants/ActionTypes";
import {
  hideAuthLoader,
  showAuthMessage,
  userSignInSuccess,
  userSignOutSuccess,
} from "appRedux/actions/Auth";
import { HttpStatus } from "constants/HttpStatus";
import URLs from "constants/URLs";
import { request, isSuccessStatus } from "services/ApiRequest";
import { showAuthLoader } from "appRedux/actions";

function* signInUserWithUsernamePassword({ payload }) {
  try {
    yield put(showAuthLoader());
    const tokenResponse = yield request.POST(URLs.AUTH_USER_SIGN_IN, null, payload);

    if (
      tokenResponse?.status &&
      isSuccessStatus(tokenResponse.status) &&
      tokenResponse.data?.token
    ) {
      const signInResponse = yield request.GET(URLs.AUTH_USER_GET_USER_INFO, tokenResponse.data.token);

      if (
        signInResponse &&
        signInResponse?.status === HttpStatus.SUCCESS &&
        signInResponse?.data
      ) {
        yield put(
          userSignInSuccess({
            userInfo: signInResponse?.data,
            tokenInfo: tokenResponse.data,
          })
        );
      } else {
        yield put(showAuthMessage(signInResponse));
      }
    } else {
      yield put(showAuthMessage(tokenResponse?.data?? "Alert.Global.Error.message.not.found"));
    }
  } catch (error) {
    yield put(showAuthMessage(error));
  }
}

function* signOut() {
  try {
    yield put(userSignOutSuccess("signOutUser"));
  } catch (error) {
    yield put(showAuthMessage(error));
  }
}

export function* signInUser() {
  yield takeEvery(SIGNIN_USER, signInUserWithUsernamePassword);
}

export function* signOutUser() {
  yield takeEvery(SIGNOUT_USER, signOut);
}

export default function* rootSaga() {
  yield put(hideAuthLoader());
  yield all([fork(signInUser), fork(signOutUser)]);
}
